import { PROFILES_KEY } from './key'

export const PROFILES_STATE = {
  [PROFILES_KEY.ALL]: {
    data: [],
    status: null
  },
  [PROFILES_KEY.CURRENT]: null,
  [PROFILES_KEY.DATA]: {}
}
